import React, { Component } from "react";

export class Icon extends Component {
	render() {
		const { type, className } = this.props;
		if (typeof type === "string") {
			return (
				<img
					src={type}
					alt="icon"
					className="anticon"
					style={{
						width: 24,
						height: 24,
						objectFit: "contain",
						transform: "translateY(4px)",
					}}
				/>
			);
		}
		return (
			<>
				{React.createElement(type, {
					className: className,
					style: { fontSize: 24, transform: "translateY(4px)" },
				})}
			</>
		);
	}
}

export default Icon;
